import { Component, ElementRef, OnInit, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';
import { WaiterLoginModel } from 'src/app/share-modul/models/login/waiter-login.model';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { VenueService } from 'src/app/waiter-panel/services/venues/venue.service';
import { ManagerPinDialogComponent } from '../../manager-pin-dialog/manager-pin-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { UserModel } from "src/app/share-modul/models/user/user.model";

@Component({
  selector: 'app-login-with-pin',
  templateUrl: './login-with-pin.component.html',
  styleUrls: ['./login-with-pin.component.scss']
})
export class LoginWithPinComponent implements OnInit {
  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public loginModel: WaiterLoginModel = new WaiterLoginModel();
  public errorModel: { [k: string]: any } = {};
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public venueId: string;
  public spinner: boolean = false;

  public keypad1: Array<any> = new Array<any>();
  public keypad2: Array<any> = new Array<any>();
  public keypad3: Array<any> = new Array<any>();
  public keypad4: Array<any> = new Array<any>();

  @ViewChild('inputPin') inputPin: ElementRef;

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    this.inputPin.nativeElement.focus();
    if (!(event.key.match('^[0-9]') || event.key.startsWith('Backspace') )) {
      event.preventDefault();
    }
  }
  @HostListener('document:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent) {
    if(this.loginModel.pin.length == 4 && event.key.match('^[0-9]')){
      this.login(this.loginModel);
    }
  }
  //#endregion
  //#region Constructor
  constructor(
    public authenticationService: AuthenticationService,
    public venueService: VenueService,
    private messageService: MessageService,
    private _jwtHelperService: JwtHelperService,
    public translate: TranslateService,
    public route: ActivatedRoute,
    public _router: Router,
    public dialogService: DialogService,
  ) {
    this.keypad1.push(1,2,3);
    this.keypad2.push(4,5,6);
    this.keypad3.push(7,8,9);
    this.keypad4.push(' ',0,'errase');
  }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      this.venueId = params['id'];
    });
  }

  public login(model: WaiterLoginModel): void {
    this.errorModel = {};
    this.spinner = true;
    if (!model.pin || model.pin.trim() === "") {
      this.errorModel['Pin'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      if (this.venueId) {
        model.VenueId = this.venueId;
      }
      this.authenticationService.waiterLogin(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            localStorage.setItem('waiter_access_token', response.jwtToken);
            localStorage.setItem('waiter_refresh_token', response.refreshToken);
            localStorage.removeItem('pos_access_token');
            localStorage.removeItem('refresh_token');
            const decodedToken = this._jwtHelperService.decodeToken(response.jwtToken);
            const loggedInUser = new UserModel(decodedToken.id, decodedToken.rlnm.split(',').map((x: string) => +x));
            this.authenticationService.loginUser.next(loggedInUser);
            if (decodedToken.rlnm.includes(RoleNameEnum.Waiter)) {
              this._router.navigate(['/waiter', this.venueId, 'wtr']);
            }
          },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error.errors && errorResponse.error.errors.Pin) {
              errorResponse.error.errors.Pin.forEach((error: string) => {
                this.errorModel['Pin'] = error;
              });
            }
            if (errorResponse.error && errorResponse.error.Message) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.Message, life: 2000 });
            }
            else if (errorResponse.error && !errorResponse.error.errors) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
            }
          }
        });
    }
  }

  public unpairDevice(model: WaiterLoginModel): void {
    const ref = this.dialogService.open(ManagerPinDialogComponent, {
      header: this.translate.instant('PIN.MANAGER_PIN'),
      data: {
        venueId : this.venueId,
      },
      width: '400px'
    });
    ref.onClose.subscribe((item: any) => {
      if(!item){
        this.messageService.add({ severity: 'error', summary: 'Wrong credentials!', life: 2000 });
      }
      // this.loadProfileInfo();
      // if (item) {
      //   let summary = this.translate.instant("HEADER.PROFILE_UPDATED");
      //   this.messageService.add({severity: 'success', summary, life: 3000});
      // }
    });
  }

  public addValue(item: any): void {
    if (this.loginModel.pin.length <= 3){
      if((item != ' ' && item != 'errase') || (item === 0)){
        this.loginModel.pin = this.loginModel.pin.concat(item);
      } else if(item == 'errase'){
        this.loginModel.pin = this.loginModel.pin.substring(0, -1);
      }
    }else {
      if(item == 'errase'){
        this.loginModel.pin = this.loginModel.pin.substring(0, -1);
      }
    }
    
    if(this.loginModel.pin.length == 4){
      this.login(this.loginModel);
    }
  }

}
